import { createReducer } from 'redux-act';
import {
  ROOM_CREATE_INIT,
  ROOM_CREATE_SUCCESS,
  ROOM_CREATE_FAIL,
  ROOM_FETCH_INIT,
  ROOM_FETCH_SUCCESS,
  ROOM_FETCH_FAIL,
  ROOM_FETCH_BY_ID_INIT,
  ROOM_FETCH_BY_ID_SUCCESS,
  ROOM_FETCH_BY_ID_FAIL,
  ROOM_UPDATE_INIT,
  ROOM_UPDATE_SUCCESS,
  ROOM_UPDATE_FAIL,
  ROOM_DELETE_INIT,
  ROOM_DELETE_SUCCESS,
  ROOM_DELETE_FAIL,
  ROOM_DELETE_MEDIA_INIT,
  ROOM_DELETE_MEDIA_SUCCESS,
  ROOM_DELETE_MEDIA_FAIL,
} from '../actions/room';

const initialState = {
  loading: false,
  rooms: [],
  filteredRooms: [],
  currentRoom: null,
  error: null,
};

const room = createReducer(
  {
    [ROOM_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [ROOM_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      rooms: [...state.rooms, payload.room],
      error: null,
    }),
    [ROOM_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ROOM_FETCH_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [ROOM_FETCH_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      rooms: payload.rooms,
      filteredRooms: payload.filteredRooms,
      error: null,
    }),
    [ROOM_FETCH_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ROOM_FETCH_BY_ID_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [ROOM_FETCH_BY_ID_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      currentRoom: payload.room,
      error: null,
    }),
    [ROOM_FETCH_BY_ID_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ROOM_UPDATE_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [ROOM_UPDATE_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      currentRoom: payload.room,
      rooms: state.rooms.map(room =>
        room._id === payload.room._id ? payload.room : room
      ),
      error: null,
    }),
    [ROOM_UPDATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ROOM_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [ROOM_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      rooms: state.rooms.filter(room => room._id !== payload.roomId),
      error: null,
    }),
    [ROOM_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ROOM_DELETE_MEDIA_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [ROOM_DELETE_MEDIA_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      currentRoom: payload.room,
      rooms: state.rooms.map(room =>
        room._id === payload.room._id ? payload.room : room
      ),
      error: null,
    }),
    [ROOM_DELETE_MEDIA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
  },
  initialState
);

export default room;
